import { v4 as uuidv4 } from 'uuid'
import { RequirementDraft, SectionDraft } from './FrameworkSectionsEditor.types'

export const createEmptyRequirementDraft = (): RequirementDraft => ({
  tempId: uuidv4(),
  name: '',
  description: '',
  controlIds: [],
})

export const createEmptySectionDraft = (): SectionDraft => ({
  tempId: uuidv4(),
  name: '',
  description: '',
  requirements: [],
})
